module.exports = __webpack_public_path__ + "img/sld_isolator_t1_b1_disable.0766dfdc.svg";